import { AgGridReactProps } from '@ag-grid-community/react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ActionTypes, AgGridColumnDef, ClientMessagesStatusEnum } from '@tassat/common-definitions';
import { ClientMessageRecord, UserRecord, UserRole } from '@tassat/payments-definitions';
import { ConfirmationWorkflowContext } from '@tassat/workflow';
import React from 'react';

import ActionsDropdownMenu from 'SharedComponents/actionsDropdownMenu/actionsDropdownMenu';

interface IActionButtonsAGGridProps extends AgGridReactProps{
    //Column passed in for data should be object that contains the IsLocked value
    data: ClientMessageRecord;
    colDef: AgGridColumnDef;
    currentUser: UserRecord;
    userRole: UserRole;
}

const muiStyles = makeStyles({
    root: { height: '100%' },
    lockContainer: { lineHeight: 'initial' as const },
    showActionsButton: { marginLeft: 'auto' as const }
});

export function ClientMessageContextMenuRenderer(props: IActionButtonsAGGridProps) {
    const {
        data,
        colDef
    } = props;

    const { preActionValidationAndConfig } = React.useContext(ConfirmationWorkflowContext).confirmationWorkflowState;

    const classes = muiStyles(props);

    const messageActions: ActionTypes[] = React.useMemo(() => {
        const actions = [];

        if (data.Status === ClientMessagesStatusEnum.DECLINED && preActionValidationAndConfig[ActionTypes.edit]) {
            actions.push(ActionTypes.edit);
        }
        if (data.Status !== ClientMessagesStatusEnum.CANCELLED && data.Status !== ClientMessagesStatusEnum.ENDED &&
            preActionValidationAndConfig[ActionTypes.cancel]) {
            actions.push(ActionTypes.cancel);
        }

        return actions;
    }, [ data.Status, preActionValidationAndConfig ]);

    if (!preActionValidationAndConfig || !colDef) return <div />;

    return (
        <Grid
            alignItems='flex-start'
            className={classes.root}
            container
            direction='row'
            justifyContent='space-between'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                className={classes.showActionsButton}
                item
            >
                {messageActions.length > 0 ?
                    <ActionsDropdownMenu
                        actions={messageActions}
                        data={data}
                    />
                    : null}
            </Grid>
        </Grid>
    );
}

export default ClientMessageContextMenuRenderer;